import { Box, Link, Typography } from "@mui/material";
import { InfoIconTooltip } from "components/InfoIconTooltip";

export const WasteTagsColumnHeader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        fontWeight: "medium",
      }}
    >
      Tags
      <InfoIconTooltip
        tooltip={
          <Typography variant="caption">
            Tags are used to further organize specific types of waste. Learn more{" "}
            <Link
              href="https://support.encamp.com/en/articles/8232961"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: (theme) => theme.palette.primary.main + " !important",
              }}
            >
              here.
            </Link>
          </Typography>
        }
        fontSize="small"
      />
    </Box>
  );
};
